import { render, staticRenderFns } from "./TradeConfigSave.vue?vue&type=template&id=c36b6d3c&scoped=true"
import script from "./TradeConfigSave.vue?vue&type=script&lang=js"
export * from "./TradeConfigSave.vue?vue&type=script&lang=js"
import style0 from "./TradeConfigSave.vue?vue&type=style&index=0&id=c36b6d3c&prod&scoped=true&lang=css"
import style1 from "./TradeConfigSave.vue?vue&type=style&index=1&id=c36b6d3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b6d3c",
  null
  
)

export default component.exports